<template>
  <app-modal
      :modal-id="modalId"
      :title="title"
      :preloader="preloader"
      @submit="submit"
      @close-modal="closeModal"
      modal-size="large"
      modal-alignment="top"
  >
    <template slot="header">
      <h5 class="modal-title">{{ title }}</h5>
      <button
          type="button"
          class="close outline-none"
          data-dismiss="modal"
          aria-label="Close"
      >
        <span>
          <app-icon :name="'x'"></app-icon>
        </span>
      </button>
    </template>

    <template slot="body">
      <app-overlay-loader v-if="preloader" />
      <form
          :class="{ 'loading-opacity': preloader }"
          ref="form"
          :data-url="
          selectedUrl
            ? `/masterData/activities/${inputs.id}`
            : `/masterData/activities`
        "
      >
        <div class="row">

          <div class="col-12">
            <div class="form-group">
              <label class="mb-0">Código</label>
              <app-input
                  type="text"
                  v-model="inputs.text_scope_code"
                  placeholder="Ingrese código de alcance"
                  :required="true"
              />
            </div>
          </div>



          <div class="col-12 mb-5">
            <div class="form-group">
              <label class="mb-0">Texo principal</label>
              <quill-editor v-model="inputs.text_scope_main" :options="editorOption" />
            </div>
          </div>

          <br/><br/><br/>

          <div class="col-12 mt-5">
            <div class="form-group">
              <label class="mb-0">Texto secundario</label>
              <quill-editor v-model="inputs.text_scope_secondary" :options="editorOption" />
            </div>
          </div>


        </div>
      </form>
    </template>

    <template slot="footer">
      <button
          type="button"
          class="btn btn-secondary mr-2"
          data-dismiss="modal"
          @click="closeModal"
      >
        Cerrar
      </button>
      <button type="button" class="btn btn-primary" @click="submit">
        Guardar
      </button>
    </template>
  </app-modal>
</template>


<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import { ModalMixin } from "@/app/Mixins/ModalMixin";
import { quillEditor } from "vue-quill-editor";

export default {
  mixins: [FormMixin, ModalMixin],
  components: {quillEditor},
  props: {
    tableId: String,
    modalTitle: String,
    editModalTitle: String,
    accreditationAreaList: Array,
  },
  data() {
    return {
      preloader: false,
      inputs: {
        rules: [],
      },
      modalId: "activities-modal-text-add-edit",
      isActive: [
        {
          id: 1,
          value: "SI",
        },
        {
          id: 0,
          value: "NO",
        },
      ],
      isRequest: [
        {
          id: 1,
          value: "SI",
        },
        {
          id: 0,
          value: "NO",
        },
      ],
      rulesList: [],
      editorOption: {
        placeholder: "Inserte el texto aquí..",
        modules: {
          toolbar: [
            [{ size: ["small", false, "large", "huge"] }],
            [
              "bold",
              "italic",
              "underline",
              "strike",
              { color: [] },
              { background: [] },
            ],
            [{ align: [] }],
            [
              { list: "ordered" },
              { list: "bullet" },
              { indent: "-1" },
              { indent: "+1" },
            ],
            ["clean"],
          ],
        },
      }
    };
  },
  computed: {
    title() {
      return this.selectedUrl ? this.editModalTitle : this.modalTitle;
    },
  },
  created() {
    if (this.selectedUrl) {
      this.preloader = true;
    }
  },
  methods: {
    submit() {
      this.save(this.inputs);
    },
    afterSuccess(response) {
      if (this.selectedUrl != "") {
        this.$toastr.s(this.$t("updated_success"));
      } else {
        this.$toastr.s(this.$t("created_success"));
      }
      this.$hub.$emit("reload-" + this.tableId);
    },
    afterSuccessFromGetEditData(response) {
      const tmp = response.data;
      tmp.rules = tmp.rules.map((item) => item.selected_id);
      this.inputs = tmp;
      this.preloader = false;
    },
    afterFinalResponse() {
      this.closeModal();
      this.preloader = false;
    },
    afterError(res) {
      this.$toastr.e(res.data.message);
    },
    getOptions() {
      let url = `/masterData/rulesAccreditation/getOptions`;
      this.axiosGet(url)
          .then((response) => {
            if (response.status == 200) {
              this.rulesList = response.data;
            }
          })
          .catch(({ error }) => {
            console.log(error);
          });
    },
  },
};
</script>
